import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: '[ideals-default-bg]',
  templateUrl: './default-bg.component.html',
  styleUrls: ['./default-bg.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DefaultBgComponent {
  @Input()
  public defaultBackgroundClass = '';
}
